<template>
  <div class="table-container-main">
    <div class="confirm-svg">
        <svg style="padding-left: 5px;" height="50px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 180.36">
            <g id="image">
                <path d="M83.82,107.32c-.8,.6-1.89,.64-2.73,.09-9.02-5.68-17.02-12.82-23.68-21.13-8.16-9.91-13.64-21.75-15.94-34.38-1.89-11.72-.09-22.99,5.78-32.17,2.37-3.73,5.35-7.03,8.8-9.77C63.62,3.64,73.14,.13,82.99,0c9.55,.15,18.69,3.88,25.62,10.45,2.66,2.44,4.96,5.25,6.84,8.33,6.27,10.27,7.62,23.48,4.86,36.86-4.67,21.46-17.84,40.1-36.49,51.68Zm-26.82,1.36v40.6l44,18.97v-52.69l8-7.93v60.34l37-18.63V67.47l-15.02,5.78c1.51-3.98,2.75-8.06,3.72-12.2l14.53-5.61c2.58-.94,5.44,.36,6.42,2.92,.23,.58,.34,1.19,.34,1.81v92.18c0,1.93-1.16,3.68-2.95,4.42l-45.95,23.08c-1.35,.68-2.95,.68-4.3,0l-51.55-22.34L6.89,179.85c-2.34,1.18-5.19,.25-6.37-2.09,0,0,0,0,0,0C.18,177.09,0,176.36,0,175.62V78.41c0-2.22,1.46-4.17,3.59-4.8l25.36-9.78c.94,3.19,2.06,6.33,3.34,9.4l-22.29,8.59v86.19l37-18.63v-51.2c3.11,3.71,6.45,7.22,10,10.51ZM81.22,20.85c11.12,0,20.13,9.01,20.13,20.13s-9.01,20.13-20.13,20.13-20.13-9.01-20.13-20.13,9.01-20.13,20.13-20.13h0Z" style="fill: #000; fill-rule: evenodd;"/>
            </g>
        </svg>
        <h2>Route</h2>
    </div>
    <div class="button-container">
        <button 
            class="print-selected-text"
            @click="refreshRouteTable"
            :disabled="loadingTable"
        >
            {{ loadingTable ? 'Refreshing...' : 'Refresh Routes' }}
        </button>
    </div>
    <table-filter :filterByManifestStatus="true" :filterByRouteCode="true" :setIsoDateTime="this.isoDateTime" @filterValues="filterValues($event)"/>
    <div class="responsive-table">
        <!-- <div class="table-header" id="header">
            <div class="col-1">Route Code</div>
            <div class="col-2">Manifest Status</div>
            <div class="col-3">Last Updated</div>
        </div> -->
        <div class="table-header" id="header">
            <div class="col-1 sortable" @click="sortBy('routeCode')">
                Route Code
                <span v-if="sortKey === 'routeCode'">
                    {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
            </div>

            <div class="col-2 sortable" @click="sortBy('manifestStatus')">
                Manifest Status
                <span v-if="sortKey === 'manifestStatus'">
                    {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
            </div>

            <div class="col-3 sortable" @click="sortBy('updatedAt')">
                Last Updated
                <span v-if="sortKey === 'updatedAt'">
                    {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
            </div>
        </div>
        <loading-charts v-if="loadingTable" class="loading-charts"/>
        <div class="table-row-container">
            <div v-if="sortedRouteTableData.length > 0">
                <div class="table-row" v-for="(routeCode, index) in sortedRouteTableData" :key="index">
                    <div class="col-1"><p class="shipmentid-text" id="shipmentid-text" @click="getRouteDataClick(routeCode.routeCode, routeCode.openManifestAction, routeCode.manifestStatus)">{{routeCode.routeCode}}</p></div>
                    <div class="col-2"><p class="service-text">{{routeCode.manifestStatus}}</p></div>
                    <div class="col-3"><p class="service-text">{{routeCode.updatedAt}}</p></div>
                    <!-- <div class="col-4"><input v-if="isFiltered" type="checkbox" name="" id="" :value="{geoCode: routeCode.geoCode, serviceNetwork: routeCode.serviceNetwork, routeCode: routeCode.routeCode}" v-model="selectedGeoServiceNetworkItems"></div> -->
                </div>
            </div>
            
            <div v-if="sortedRouteTableData.length == 0" class="table-row">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                <div class="col-2 col-data">No Routes</div>
                <div class="col-3 col-data"><p class="service-text"></p></div>
            </div>
        </div>
    </div>
  </div>
<route-info v-if="toggleAddressBookInfo" @closeAddressInfo="closeAddressInfo($event)" :geoCodeID="geoCodeID" :serviceNetwork="serviceNetwork"/>
<route-update-list v-if="toggleRouteUpdateList" @closeAddressInfo="closeAddressInfo($event)" :selectedGeoServiceNetworkItems="selectedGeoServiceNetworkItems" :filterField="filterField" :filterValue="filterValue"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue'
import RouteInfo from '../RouteDashboard/RouteInfo.vue'
import RouteUpdateList from '../RouteDashboard/RouteUpdateList.vue'
import TableFilter from '../TableFilter.vue'

export default {
    components:{
        AlertUser,
        LoadingCharts,
        RouteInfo,
        TableFilter,
        RouteUpdateList
    },
    props: ['jwtToken', 'selectedUserData', 'refreshKey'],
    mounted(){
        this.listRouteData();
        // If a routecode query param is present (e.g. redirect from Same Day initiate),
        // auto-select that route so its manifest data loads immediately.
        this.autoSelectRouteFromQuery();
    },
    watch:{
        async 'refreshKey'(){
            console.log("UPDATE TABLE")
            await this.GetRouteByRouteCode(this.geoCodeID);
            console.log("GEOCODE DATA: ", this.routeTableData)
            await this.getRouteDataClick(this.routeTableData[0].routeCode, this.routeTableData[0].openManifestAction, this.routeTableData[0].manifestStatus);
        }
    },
    // watch: {
    //     async refreshKey() {
    //         console.log("UPDATE TABLE");

    //         if (this.filterField === "routeCode" && this.filterValue) {
    //             await this.GetRouteByRouteCode(this.filterValue);

    //             const route = this.routeTableData?.[0];

    //             if (route) {
    //                 await this.getRouteDataClick(
    //                     route.routeCode,
    //                     route.openManifestAction,
    //                     route.manifestStatus
    //                 );
    //             }

    //             return;
    //         }

    //         await this.listRouteData();

    //         const route = this.sortedRouteTableData?.[0];

    //         if (route) {
    //             await this.getRouteDataClick(
    //                 route.routeCode,
    //                 route.openManifestAction,
    //                 route.manifestStatus
    //             );
    //         }
    //     }
    // },
    data(){
        return{
            toggleAddressBookInfo: false,
            toggleRouteUpdateList: false,
            id: null,
            geoCodeID: null,
            serviceNetwork: null,
            routeTableData: [],
            loadingTable: false,
            toggleAlertBox: '',
            alertMessage: '',
            selectedIndex: null,
            filterField: null,
            filterValue: null,
            filterEvent: null,
            isFiltered: false,
            selectedGeoServiceNetworkItems: [],
            selectAllChecked: false,
            isoDateTime: null,
            sortKey: 'updatedAt',
            sortDirection: 'desc',
            manifestStatusFilter: null
        }
    },
    computed: {
        sortedRouteTableData() {
            let filteredData = this.routeTableData;

            // On ManifestDashboard, only show routes that have an openManifestAction
            if (this.$route.name === 'ManifestDashboard') {
                filteredData = filteredData.filter(route => route?.openManifestAction);
            }

            if (this.manifestStatusFilter) {
                filteredData = filteredData.filter(
                    route => route?.manifestStatus === this.manifestStatusFilter
                );
            }

            return [...filteredData].sort((a, b) => {
                const aVal = a?.[this.sortKey] || "";
                const bVal = b?.[this.sortKey] || "";

                if (this.sortKey === "updatedAt") {
                    const aTime = aVal ? Date.parse(aVal) : 0;
                    const bTime = bVal ? Date.parse(bVal) : 0;

                    return this.sortDirection === "asc"
                        ? aTime - bTime
                        : bTime - aTime;
                }

                const valA = String(aVal).toLowerCase().trim();
                const valB = String(bVal).toLowerCase().trim();

                if (valA < valB) return this.sortDirection === "asc" ? -1 : 1;
                if (valA > valB) return this.sortDirection === "asc" ? 1 : -1;
                return 0;
            });
        }
    },
    methods:{
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortKey = key;
                this.sortDirection = 'asc';
            }
        },
        filterByManifestStatus(status) {
            this.manifestStatusFilter = status;
        },
        clearManifestStatusFilter() {
            this.manifestStatusFilter = null;
        },
        async refreshRouteTable() {
            if (this.filterField === "routeCode" && this.filterValue) {
                await this.GetRouteByRouteCode(this.filterValue);
                return;
            }

            await this.listRouteData();
        },
        async filterValues(event){
            await this.listRouteData();
            console.log(event)
            this.isFiltered = true;
            this.filterEvent = event;
            this.filterField = event.filterField;
            this.filterValue = event.filterValue;
            this.isoDateTime = event.isoDateTime ?? null;

            switch (event.filterField) {
                case "routeCode":
                    this.GetRouteByRouteCode(event.filterValue)
                    break;
                case "manifestStatus":
                    this.filterByManifestStatus(event.filterValue)
                    break;
                default:
                    break;
            }
        },
        async GetRouteByRouteCode(filterValue) {
            this.loadingTable = true;
            this.routeTableData = [];

            let getRoute = `query getRoute {
                getRoute(routeCode: "${filterValue}") {
                    openManifestAction
                    routeCode
                    routeId
                    manifestCutoffTime
                    manifestStatus
                    updatedAt
                }
            }`;

            try {
                let getRouteData = await API.graphql({
                    query: getRoute,
                    variables: {
                        routeCode: filterValue
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                if(getRouteData.data.getRoute == null){
                    this.routeTableData = []
                    this.loadingTable = false;
                    return;
                }

                this.routeTableData = this.routeTableData.concat(getRouteData.data.getRoute);
                console.log(this.routeTableData[0].manifestCutoffTime)
                this.isoDateTime = this.routeTableData[0].manifestCutoffTime
            } catch (e) {
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting route data";
                this.loadingTable = false;
            }

            this.loadingTable = false;
        },
        async autoSelectRouteFromQuery(){
            const routeCode = this.$route?.query?.routecode;
            if(!routeCode) return;
            await this.GetRouteByRouteCode(routeCode);
            const route = this.routeTableData?.[0];
            if(route){
                // fromRedirect=true marks this as the auto-select from a routecode query param
                // (e.g. the Same Day initiate redirect) so the manifest map can widen the cutoff.
                await this.getRouteDataClick(route.routeCode, route.openManifestAction, route.manifestStatus, true);
            }
        },
        clearRouteQueryParam(){
            // Remove the routecode query param so it doesn't linger on refresh or
            // when the user moves on to a different route/task.
            if(this.$route?.query?.routecode){
                this.$router.replace({ query: {} });
            }
        },
        async getRouteDataClick(id, openManifestAction, manifestStatus, fromRedirect = false){
            this.geoCodeID = id;
            this.clearRouteQueryParam();
            // fromRedirect is false for a normal table click and true only for the auto-select
            // from a routecode query param (the Same Day redirect). The manifest map uses it to
            // widen the cutoff to end-of-day for the redirect only.
            this.$emit('selectRouteCode', {routeCode: id, isoDateTime: this.isoDateTime, openManifestAction: openManifestAction, manifestStatus: manifestStatus, fromRedirect: fromRedirect})
            // this.toggleAddressBookInfo = true;
        },
        closeAddressInfo(event){
            this.toggleAddressBookInfo = event;
            this.toggleRouteUpdateList = event;
            this.selectedGeoServiceNetworkItems = [];
            this.selectAllChecked = false;
            if(this.isFiltered == true){
                this.filterValues(this.filterEvent);
            }else{
                this.listRouteData();
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async listRouteData() {
            this.loadingTable = true;
            this.routeTableData = [];

            let nextToken = null;

            try {
                do {
                    const result = await API.graphql({
                        query: `
                            query listRoutes($nextToken: String) {
                                listRoutes(limit: 1000, nextToken: $nextToken) {
                                    items {
                                        routeCode
                                        startDepot
                                        openManifestAction
                                        manifestStatus
                                        updatedAt
                                    }
                                    nextToken
                                }
                            }
                        `,
                        variables: {
                            nextToken
                        },
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    const response = result.data.listRoutes;

                    this.routeTableData.push(...response.items);

                    nextToken = response.nextToken;

                } while (nextToken);

            } catch (e) {
                console.log(e);

                this.toggleAlertBox = true;
                this.alertMessage = "Error getting route codes";
            } finally {
                this.loadingTable = false;
                this.isFiltered = false;
            }
        }
        // async listRouteData(){
        //     this.loadingTable = true;
        //     let graphqlQuery = `query listRoutes{
        //         listRoutes(limit: 15){
        //             items{
        //                 routeCode
        //                 startDepot
        //                 openManifestAction
        //                 manifestStatus
        //                 updatedAt
        //                 }
        //             }
        //         }`
            
        //     try{
        //         let listRouteDataReturn = await API.graphql({
        //         query:  graphqlQuery,
        //         authMode: "AMAZON_COGNITO_USER_POOLS",
        //         })
                
        //         this.routeTableData = listRouteDataReturn.data.listRoutes.items;
        //     }catch(e){
        //         console.log(e)
        //         if(e){
        //             this.toggleAlertBox = true;
        //             this.alertMessage = "Error getting route codes"
        //         }
        //     }finally{
        //         this.loadingTable = false;
        //         this.isFiltered = false;
        //     }
        // }
    }
}
</script>

<style scoped>
h3{
    margin: 0;
}
.table-container-main{
    width: 100%;
    margin-top: 0;
    overflow-x: hidden;
}

.responsive-table{
    width: 100%;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
    margin-bottom: 5px;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

* {
    scrollbar-width: auto;
    scrollbar-color: #f3f3f3 #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
    width: 16px;
}

*::-webkit-scrollbar-track {
    background: #ffffff;
}

*::-webkit-scrollbar-thumb {
    background-color: #f3f3f3;
    border-radius: 10px;
    border: 3px solid #ffffff;
}

.table-header{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #32ccfe;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
    color: #fff;
}

.table-row-container{
    max-height: 350px;
    overflow-y: auto;
    border-radius: 5px;
    width: 100%;
    animation: animate-table-row 1s ease;
}

@keyframes animate-table-row{
    from{
        margin-left: -50px;
    }
    to{
        margin-left: 0px;
    }
}

.table-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f3f3f3;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
}

.table-header .col-1{
    margin-right: 5px;
}

.col-1{
    flex-basis: 20%;
    text-align: left;
    /* white-space: nowrap; */
}

.col-2{
    flex-basis: 40%;
    text-align: left;
    margin-left: 5px;
}

.col-3{
    flex-basis: 30%;
    text-align: left;
    margin-left: 5px;
}

.col-data{
    text-align: left;
    max-height: 40px;
    overflow-y: auto;
    border: 1px solid #a0a0a0;
    border-radius: 5px 0px 0px 5px;
}

.col-data p{
    overflow-x: auto;
    margin-top: 5px;
    margin-bottom: 5px;
}

.col-4{
    flex-basis: 10%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.service-text{
    background-color: #d4d4d4;
    padding: 2.5px 10px;
    border-radius: 999px;
    width: fit-content;
    margin: 0;
    font-size: 12px;
}

.shipmentid-text{
    margin: 0;
    color: #6a6a6a;
    width: fit-content;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.shipmentid-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.button-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    animation: animate-table-row 1s ease;
}

.print-selected-text{
    margin: 0;
    margin-bottom: 5px;
    margin-right: 5px;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.download-csv{
    margin-top: 5px;
}

.void-selected-text{
    margin: 0;
    margin-bottom: 5px;
    padding: 2.5px 10px;
    margin-bottom: 5px;
    border-radius: 999px;
    background-color: #fe804d;
    border: 1px solid #ff5512;
    color: #fff;
    transition-duration: .5s;
}

.print-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.void-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.close-label{
    margin-left: auto;
}

.label-container{
    width: 100%;
}

@media only screen and (max-width: 600px) {
    .service-text, .col-data{
        font-size: 8px;
    }

    .shipmentid-text{
        font-size: 10px;
    }
}
</style>